/** @format */
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { UniversitySettings, UserSettings } from 'common-typescript/types';
import * as _ from 'lodash-es';
import moment from 'moment';
import { Observable, take } from 'rxjs';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { AppErrorHandler, PlanStateService, UniversityService, UserSettingsEntityService } from 'sis-components';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'app-plan-version-toggle',
    templateUrl: './plan-version-toggle.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanVersionToggleComponent implements OnInit, AfterViewInit {
    static readonly downgrade: ComponentDowngradeMappings = {
        moduleName: 'student.planNg.planVersionToggle',
        directiveName: 'appPlanVersionToggle',
    };
    @Output() toggleChanged = new EventEmitter<boolean>();

    private readonly userSettingsEntityService = inject(UserSettingsEntityService);
    private readonly errorHandler = inject(AppErrorHandler);
    private readonly universityService: UniversityService = inject(UniversityService);
    readonly planStateService = inject(PlanStateService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    userSettings$: Observable<UserSettings>;
    universitySettings$: Observable<UniversitySettings>;
    showSurvey: boolean = moment().isBetween(moment('2025-12-18T09:00:00'), moment('2026-01-30T23:59:59'));

    ngOnInit(): void {
        this.userSettings$ = this.userSettingsEntityService.getOwnSettings().pipe(this.errorHandler.defaultErrorHandler());
        this.universitySettings$ = this.universityService.getCurrentUniversitySettings().pipe(this.errorHandler.defaultErrorHandler());
    }

    ngAfterViewInit(): void {
        if (this.planStateService.versionChanged) {
            this.planStateService.versionChanged = false;
        }
        this.changeDetectorRef.detectChanges();
    }

    toggle(settings: UserSettings, isNewPlanVersionInUse: boolean): void {
        this.saveUserSettings(settings, isNewPlanVersionInUse).subscribe({
            next: () => {
                this.toggleChanged.emit(isNewPlanVersionInUse);
                this.planStateService.versionChanged = true;
                this.changeDetectorRef.markForCheck();
            },
        });
    }

    private saveUserSettings(settings: UserSettings, isNewPlanVersionInUse: boolean) {
        const settingsCopy = _.cloneDeep(settings);
        settingsCopy.isNewPlanVersionInUse = isNewPlanVersionInUse;
        return this.userSettingsEntityService.saveOwnSettings(settingsCopy).pipe(take(1), this.errorHandler.defaultErrorHandler());
    }
}
